import {ComponentHelper, MappedWirtschaftsjahrAngaben, WirtschaftsjahrHelper, WizardPageBaseComponent} from '@utils-lib';
import {Component, OnInit} from '@angular/core';
import {AppNameEnum, BeginnTaetigkeitWjStammkapitalAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'common-ui-beginn-taetigkeit-wj-stammkapital-angaben',
    templateUrl: './beginn-taetigkeit-wj-stammkapital-angaben.component.html'
})
export class BeginnTaetigkeitWjStammkapitalAngabenComponent extends WizardPageBaseComponent<BeginnTaetigkeitWjStammkapitalAngaben>
    implements OnInit {

    static nutzdatenPath = 'beginnTaetigkeitWjStammkapitalAngaben';
    static route = 'beginn-taetigkeit-wj-stammkapital-angaben';

    public wirtschaftsJahrStammdaten: MappedWirtschaftsjahrAngaben;
    public isKapGAus = false;

    constructor(protected readonly activatedRoute: ActivatedRoute) {
        super(activatedRoute);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.wirtschaftsJahrStammdaten = WirtschaftsjahrHelper.mapWirtschaftsJahrDaten(this.stammdaten?.unternehmen?.wirtschaftsJahr);

        const appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);
        if (appEnum === AppNameEnum.FragebogenKapGAus) {
            this.isKapGAus = true;
        }
    }

    public onWirtschaftsjahrPicked(): void {
        const wirtschaftsJahr = WirtschaftsjahrHelper.mapWirtschaftsJahrDaten(this.stammdaten?.unternehmen?.wirtschaftsJahr);
        this.data.eroeffnungsbilanzWjAngabe = {
            wirtschaftsJahr: wirtschaftsJahr.isAbweichend,
            abweichendesWirtschaftsjahrVon: wirtschaftsJahr.von
        };
    }

    protected getStammdatenMappingRules(): Map<string, unknown> {
        const wirtschaftsJahr = WirtschaftsjahrHelper.mapWirtschaftsJahrDaten(this.stammdaten?.unternehmen?.wirtschaftsJahr);
        return new Map<string, unknown | Array<unknown>>([
            ['taetigkeitBeginnAngabe.beginnDerTaetigkeit', this.stammdaten?.unternehmen?.beginnTaetigkeit],
            ['eroeffnungsbilanzWjAngabe.wirtschaftsJahr', wirtschaftsJahr?.isAbweichend],
            ['eroeffnungsbilanzWjAngabe.abweichendesWirtschaftsjahrVon', wirtschaftsJahr?.von]
        ]);
    }

}
